if (!customElements.get('bluno-product-inquiry')) {
  customElements.define('bluno-product-inquiry', class extends HTMLElement {
    connectedCallback() {
      const dataNode = this.querySelector('[data-inquiry-data]');
      if (!dataNode) return;
      try { this.inquiryData = JSON.parse(dataNode.textContent); } catch { return; }
      this.productInfo = this.closest('product-info');
      const visibleTitle = this.productInfo?.querySelector('.product__title h1')?.textContent.trim().replace(/\s+/g, ' ');
      if (visibleTitle) this.querySelector('.bluno-product-inquiry__product-title').textContent = visibleTitle;
      this.form = this.querySelector('form');
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.options = this.querySelector('[data-inquiry-options]');
      this.variantInput = this.querySelector('[data-inquiry-variant]');
      this.selectionInput = this.querySelector('[data-inquiry-selection]');
      this.urlInput = this.querySelector('[data-inquiry-url]');
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.details.addEventListener('toggle', () => {
        this.summary.setAttribute('aria-expanded', String(this.details.open));
        if (this.details.open) this.syncVariant();
      }, { signal });
      this.productInfo?.addEventListener('change', (event) => {
        if (event.target.name === 'id') this.syncVariant();
      }, { signal });
      this.form.addEventListener('submit', () => this.syncVariant(), { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details.open) {
          this.details.open = false;
          this.summary.focus();
        }
      }, { signal });
      this.summary.setAttribute('aria-expanded', String(this.details.open));
      this.syncVariant();
    }

    disconnectedCallback() { this.abortController?.abort(); }

    syncVariant() {
      const productForm = this.productInfo?.querySelector('product-form form[data-type="add-to-cart-form"]');
      const selectedId = productForm?.querySelector('input[name="id"]')?.value ?? this.dataset.selectedVariant;
      const variant = this.inquiryData.variants.find((item) => String(item.id) === String(selectedId));
      const translate = (value) => this.inquiryData.translations[value] ?? value;
      const selections = this.inquiryData.hasOnlyDefaultVariant || !variant ? [] : variant.options.map((value, index) => ({
        name: translate(this.inquiryData.optionNames[index]),
        value: translate(value),
      }));
      this.options.replaceChildren(...selections.map(({ name, value }) => {
        const row = document.createElement('p');
        row.textContent = name + ': ' + value;
        return row;
      }));
      if (!variant && !this.inquiryData.hasOnlyDefaultVariant) {
        const row = document.createElement('p');
        row.textContent = this.inquiryData.unselected;
        this.options.append(row);
      }
      this.variantInput.value = variant?.id ?? '';
      this.selectionInput.value = selections.map(({ name, value }) => name + ': ' + value).join(' / ');
      const productUrl = new URL(this.dataset.productUrl, window.location.origin);
      if (variant) productUrl.searchParams.set('variant', variant.id);
      this.urlInput.value = productUrl.toString();
      const returnUrl = new URL(this.dataset.returnPath, window.location.origin);
      if (variant) returnUrl.searchParams.set('variant', variant.id);
      const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewId) returnUrl.searchParams.set('preview_theme_id', previewId);
      returnUrl.hash = this.dataset.anchor;
      const returnInput = this.form.querySelector('input[name="return_to"]');
      if (returnInput) returnInput.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
    }
  });
}
